import { idmsApi } from "./api";
import {
  API_FORGOT_PASSWORD_ENDPOINT,
  API_RESET_PASSWORD_ENDPOINT,
} from "../../constants/endpoints";

/** Payload for requesting a password reset link. */
export interface ForgotPasswordRequest {
  email: string;
}

/** Generic, non-enumerating response returned by the forgot-password endpoint. */
export interface ForgotPasswordResponse {
  message: string;
}

/** Payload for completing a password reset with the emailed token. */
export interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

const accountApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    // Requests a password reset link. Response is intentionally identical whether or not the account exists.
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: (request) => ({
        url: API_FORGOT_PASSWORD_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),

    // Completes the reset using the emailed token. Returns 204 No Content on success.
    resetPassword: builder.mutation<void, ResetPasswordRequest>({
      query: (request) => ({
        url: API_RESET_PASSWORD_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const { useForgotPasswordMutation, useResetPasswordMutation } = accountApi;
